/**
 * Форматирование PHP даты в удобочитаемый формат (dd.mm.YYYY, HH:MM)
 * @param {Date,string} date
 * @param {boolean} show_date Отображать дату?
 * @param {boolean} show_time Отображать время?
 * @returns {string}
 */
export const datetimeFormat = (date, show_date = true, show_time = true) => {
    if(!show_date && !show_time) return '';

    let options = {};

    if(show_date) {
        options.day     = '2-digit';
        options.month   = '2-digit';
        options.year    = 'numeric';
    }

    if(show_time) {
        options.hour    = '2-digit';
        options.minute  = '2-digit';
    }

    return typeof date === 'string'
        ? new Date(date).toLocaleString('ru', options)
        : date.toLocaleString('ru', options);
};

export const datetimeUtilsMixin = {
    methods: {
        datetimeFormat: datetimeFormat,
    }
};
